import { useTranslation } from "react-i18next";

/**
 * The current language code ("lt" or "en"). It is read through a cast because src/i18next.d.ts
 * resolves the module name "i18next" to itself (baseUrl is src), so the library's own typing of
 * `i18n.language` is never seen.
 */
export function useLanguage(): string {
  const { i18n } = useTranslation();
  return (i18n as unknown as { language: string }).language;
}
